import CutwiseAPIClient, { METHOD_DELETE } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';

export const PATH_MEDIASOURCES = 'api/v2/mediasources';

export default class MediaSourcesAPI {
  remove(mediaSourceId: string): Promise<QueryResult> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_DELETE)
      .path(`${PATH_MEDIASOURCES}/${mediaSourceId}`);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
